import { DmbWebConfig } from './dmb-web-config';

export const environment: DmbWebConfig = {
  stage: 'prod',
  production: true,
  sentryDsn: 'https://bec91b6e43a0d4a4dfdfdc5e0c5de244@o4507407783821312.ingest.de.sentry.io/4508086013526096',
  v2Target: 'https://api.kontornewmedia.com',
  firebaseConfig: {
    apiKey: 'AIzaSyA7_Eh-Qzp7jCO6I64uM7_iwDOTbdbcJ1w',
    authDomain: 'knm-dmb-firebase.firebaseapp.com',
    projectId: 'knm-dmb-firebase',
    storageBucket: 'knm-dmb-firebase.firebasestorage.app',
    messagingSenderId: '744467535754',
    appId: '1:744467535754:web:4d67e6d7c28ac5459bda73',
  },
  matomoConfig: {
    trackerUrl: 'https://analytics.kontornewmedia.com',
    siteId: 2,
    tagManagerContainerUrl: 'https://analytics.kontornewmedia.com/js/container_WYiJj7ew.js',
  },
};
